import * as Actions from '../../actions'


const initialState={
    data: {},
    isLoading: false,
    isLoaded : false,
    error: false
};

const loyalty = function (state = initialState, action) {
    switch (action.type) {
      
            
        case Actions.GET_VENUE_LOYALTY: {
            return {
                ...state,
                isLoading: true,
                isLoaded : false,
                error: false
            };
        }
        case Actions.GET_VENUE_LOYALTY_SUCCESS: {

            return {
                ...state,
                data: {...state.data, ...action.payload},
                isLoading: false,
                isLoaded : true,
                error: false
            };
        }
        case Actions.GET_VENUE_LOYALTY_ERROR: {
            return {
                ...state,
                isLoading: false,
                isLoaded : false,
                error: action.error
            };
        }
            
        case Actions.LOGOUT: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.LOGOUT_SUCCESS: {
            return {
                data: {},
                isLoading: false,
                error: false
            }
        }
        case Actions.LOGOUT_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        }
            

        default: {
            return state;
        }
    }
};

export default loyalty;